module.exports = __webpack_public_path__ + "img/1542416465.8c76a632.jpg";